import { render, staticRenderFns } from "./ModalTrash.vue?vue&type=template&id=4ba2ba9a&"
import script from "./ModalTrash.vue?vue&type=script&lang=js&"
export * from "./ModalTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports